



















































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import ProductState from '@/components/Products/ProductState.vue';
import DepositFixedTermSettings from '@/models/Products/ProductSettings/DefaultSettings/FixedTerm/DepositFixedTermSettings';
import DepositFixedTermSettingsEditDialog from '@/components/Products/ProductSettings/DefaultSettings/FixedTerm/DepositFixedTermSettingsEditDialog.vue';
import EntityType from '@/models/Shared/EntityType';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'DepositFixedTermSettingsRead', components: { ProductState, DepositFixedTermSettingsEditDialog } })
export default class extends SaascadaVueFieldGroup {

    EntityType = EntityType;
    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: DepositFixedTermSettings;

    @Prop({required: true})
    entityType: EntityType;

    get settingsAvailable() {
        return (this.settings !== undefined);
    }
}
